import type { EnrichedOpportunity, RelatedNews } from '@/models/marketData';

export interface NewsFeedItem extends RelatedNews {
  symbols: string[];
}

export const collectNews = (opportunities: EnrichedOpportunity[]): NewsFeedItem[] => {
  const articles = new Map<string, NewsFeedItem>();
  opportunities.forEach((opportunity) => {
    opportunity.relatedNews.forEach((article) => {
      const key = article.articleLink || `${article.heading}-${article.publishedTime}`;
      const existing = articles.get(key);
      if (existing) {
        if (!existing.symbols.includes(opportunity.tradeInstrument.symbol)) {
          existing.symbols.push(opportunity.tradeInstrument.symbol);
        }
      } else {
        articles.set(key, { ...article, symbols: [opportunity.tradeInstrument.symbol] });
      }
    });
  });
  return [...articles.values()].sort(
    (a, b) => Date.parse(b.publishedAt) - Date.parse(a.publishedAt),
  );
};
